// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------------------------------------------
   Live-show extras: the "Verified this show" launcher and its floating window,
   and the "tonight's hosts" credit strip.

   NO PALETTE COLOUR IS WRITTEN DOWN HERE. Everything comes from the --wsb-* tokens
   declared in assets/css/BingoCard.css and re-declared by each theme, so this
   window speaks whichever look is on screen -- burnt orange and cream on an
   ordinary night, deep indigo and moonlight once the show calls After Dark --
   without this file knowing either of them exists. A theme added next winter
   themes all of it by setting a handful of variables.

   Geometry, on the other hand, is fixed: sizes, spacing and radii never come
   from a token, so changing the look can never move anything on the page.
----------------------------------------------------------------------------- */

/* --------------------------------------------------------------- launcher ---
   The launcher lives in the same .inner-sheets slot the Google Sheets button
   used to, so it inherits that slot's button styling from the inline stylesheet
   in public/index.html. Those rules are \`.inner-sheets button\` (specificity
   0,1,1), so the overrides below have to be at least as specific -- which is
   also how the palette gets in, since that inline sheet cannot see the tokens.

   The slot itself keeps a 200px floor -- the exact width of the button that
   used to live here. Nothing is drawn when there is no show on (the slot has no
   background or border of its own), but the header geometry stays put, so the
   logo does not slide sideways the moment a show ends.
--------------------------------------------------------------------------- */

.inner-sheets {
  min-width: 200px;
}

/* The label's font is pinned on the button AND on everything inside it. Every
   theme stylesheet opens with a \`* { font-family: ... }\` reset, and a universal
   selector beats an inherited value on the spans however specific the rule on
   their parent is -- so before this the label was Dosis in the everyday look
   and Helvetica under After Dark. That is wider, "Verified this show" wrapped
   to two lines, and the button grew 16px taller the moment the lights went out,
   pushing the hosts strip and the whole card down with it. Pinned, the header
   does not move when the look changes. */
.inner-sheets .wsb-live-launcher,
.inner-sheets .wsb-live-launcher * {
  font-family: 'Dosis', sans-serif;
}

.inner-sheets .wsb-live-launcher {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  line-height: 1.2;
  background: linear-gradient(to bottom, var(--wsb-surface), var(--wsb-surface-2));
  /* The readable form of the accent: this is a 14px label, not a swatch. */
  color: var(--wsb-accent-text);
  /* An inset ring rather than a border: a dark theme needs the button's edge
     drawn, and inset shadows cost no layout. */
  box-shadow: inset 0 0 0 1px var(--wsb-ring);
}

.inner-sheets .wsb-live-launcher:hover {
  background: var(--wsb-surface-hover);
}

.inner-sheets .wsb-live-launcher:focus-visible {
  outline: 2px solid var(--wsb-focus);
  outline-offset: 2px;
}

.wsb-live-launcher-dot {
  width: 9px;
  height: 9px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--wsb-live);
  box-shadow: 0 0 6px var(--wsb-live-glow);
}

.wsb-live-launcher-count {
  flex: 0 0 auto;
  min-width: 22px;
  padding: 1px 6px;
  border-radius: 999px;
  background: var(--wsb-accent);
  color: var(--wsb-accent-ink);
  font-size: 12px;
  font-weight: 700;
}

/* ----------------------------------------------------------------- window ---
   z-index sits above the confirmation toasts (1000) and below SweetAlert's
   modal layer (1060), so the "you win!" dialog is never buried.
--------------------------------------------------------------------------- */

.wsb-vw {
  position: fixed;
  z-index: 1040;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Dosis', sans-serif;
  font-size: 15px;
  color: var(--wsb-ink);
  text-align: left;
  background-color: var(--wsb-surface);
  background-image: var(--wsb-surface-image);
  border: 1px solid var(--wsb-accent);
  border-radius: 20px;
  box-shadow: 0 10px 15px var(--wsb-shadow);
}

.wsb-vw:focus {
  outline: none;
}

.wsb-vw.is-docked {
  top: 0;
  bottom: 0;
  height: auto;
}

.wsb-vw.is-dock-left {
  left: 0;
  border-left: none;
  border-radius: 0 20px 20px 0;
}

.wsb-vw.is-dock-right {
  right: 0;
  border-right: none;
  border-radius: 20px 0 0 20px;
}

/* Drag near an edge and the window leans that way before you let go, so the
   snap is never a surprise. */
.wsb-vw.will-dock-left,
.wsb-vw.will-dock-right {
  box-shadow: 0 10px 15px var(--wsb-shadow), 0 0 0 3px var(--wsb-snap-ring);
}

/* --- title bar --- */

.wsb-vw-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  padding: 9px 10px;
  background: var(--wsb-bar-bg);
  color: var(--wsb-bar-ink);
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;               /* a touch drag must move the window, not scroll the page */
}

.wsb-vw.is-dragging .wsb-vw-bar {
  cursor: grabbing;
}

.wsb-vw-dot {
  width: 9px;
  height: 9px;
  flex: 0 0 auto;
  border-radius: 50%;
  background: var(--wsb-bar-glint);
  box-shadow: 0 0 6px var(--wsb-bar-glint);
}

.wsb-vw-title {
  flex: 1 1 auto;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Not a palette colour: a hair of black under the letters so the title stays
     crisp on any bar fill, light or dark. */
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.35);
}

.wsb-vw-count {
  flex: 0 0 auto;
  min-width: 22px;
  padding: 1px 7px;
  border-radius: 999px;
  background: var(--wsb-badge-bg);
  color: var(--wsb-badge-ink);
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.wsb-vw-tools {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 0 0 auto;
}

.wsb-vw-tool {
  width: 26px;
  height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--wsb-bar-ink-muted);
  font-size: 13px;
  cursor: pointer;
}

.wsb-vw-tool:hover,
.wsb-vw-tool.is-on {
  background: var(--wsb-bar-hover);
  color: var(--wsb-bar-ink);
}

.wsb-vw-tool:focus-visible {
  outline: 2px solid var(--wsb-bar-glint);
  outline-offset: 1px;
}

/* --- list --- */

.wsb-vw-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  /* The scrollbar is part of the window, so it is painted in the window's own
     colours rather than the operating system's. Firefox takes the pair of
     colours; every other engine reads the ::-webkit- rules below. */
  scrollbar-width: thin;
  scrollbar-color: var(--wsb-line-strong) transparent;
}

.wsb-vw-body::-webkit-scrollbar {
  width: 10px;
}

.wsb-vw-body::-webkit-scrollbar-track {
  background: transparent;
}

.wsb-vw-body::-webkit-scrollbar-thumb {
  background-color: var(--wsb-line-strong);
  border: 3px solid transparent;    /* insets the thumb without changing the track width */
  border-radius: 999px;
  background-clip: padding-box;
}

.wsb-vw-body::-webkit-scrollbar-thumb:hover {
  background-color: var(--wsb-accent);
}

.wsb-vw-list {
  list-style: none;
  margin: 0;
  padding: 4px 12px 8px;
}

.wsb-vw-item {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px dashed var(--wsb-line);
}

.wsb-vw-item:last-child {
  border-bottom: none;
}

.wsb-vw-item-main {
  flex: 1 1 auto;
  min-width: 0;
}

.wsb-vw-item-text {
  display: block;
  font-size: 15px;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.wsb-vw-item-cat {
  display: inline-block;
  margin-top: 4px;
  padding: 1px 8px;
  background: var(--wsb-chip-bg);
  border: 1px solid var(--wsb-chip-line);
  border-radius: 999px;
  color: var(--wsb-accent-text);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.wsb-vw-item-time {
  flex: 0 0 auto;
  color: var(--wsb-ink-muted);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.wsb-vw-empty {
  margin: 0;
  padding: 28px 18px;
  color: var(--wsb-ink-muted);
  font-size: 15px;
  text-align: center;
}

.wsb-vw-foot {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  flex: 0 0 auto;
  padding: 6px 12px 8px;
  border-top: 1px solid var(--wsb-line);
  color: var(--wsb-ink-muted);
  font-size: 11px;
}

.wsb-vw-foot-tz {
  white-space: nowrap;
  opacity: 0.85;
}

/* --- resize grip --- */

.wsb-vw-grip {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  cursor: nwse-resize;
  touch-action: none;
  background:
    linear-gradient(135deg, transparent 52%, var(--wsb-line-strong) 52%, var(--wsb-line-strong) 62%, transparent 62%,
    transparent 72%, var(--wsb-line-strong) 72%, var(--wsb-line-strong) 82%, transparent 82%);
}

/* Docked, the only useful handle is the inner edge: it sets how wide the
   side panel is. */
.wsb-vw-grip.is-edge {
  top: 0;
  bottom: 0;
  width: 7px;
  height: auto;
  cursor: ew-resize;
  background: var(--wsb-line);
}

.wsb-vw.is-dock-left .wsb-vw-grip.is-edge {
  right: 0;
  left: auto;
}

.wsb-vw.is-dock-right .wsb-vw-grip.is-edge {
  left: 0;
  right: auto;
}

.wsb-vw-grip.is-edge:hover {
  background: var(--wsb-line-strong);
}

/* --- narrow screens: a bottom sheet beats a postage-stamp window ---
   !important because floating position and size are inline styles. */

@media (max-width: 700px) {
  .wsb-vw,
  .wsb-vw.is-docked,
  .wsb-vw.is-floating {
    left: 0 !important;
    right: 0 !important;
    top: auto !important;
    bottom: 0 !important;
    width: auto !important;
    height: 62vh !important;
    max-height: 62vh;
    border-radius: 20px 20px 0 0;
    border-left: none;
    border-right: none;
    border-bottom: none;
  }

  .wsb-vw-bar {
    cursor: default;
  }

  .wsb-vw-grip {
    display: none;
  }

  /* Docking is a pointer idea; on a phone the sheet is already glued down. */
  .wsb-vw-tool:not(.wsb-vw-close) {
    display: none;
  }
}

/* ------------------------------------------------------------ hosts strip ---
   Sits on the card's own header panel rather than on a surface of its own, so
   it reads as part of the card. Its colours come from the --wsb-onbrand-*
   tokens, which mean "on the header, whatever the header is tonight": a dark
   wash and cream text over burnt orange, a lit wash and moonlight over indigo.
--------------------------------------------------------------------------- */

.wsb-hosts {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin: 0 20px 12px;
  padding: 7px 16px;
  border: 1px solid var(--wsb-onbrand-line);
  border-radius: 20px;
  background: var(--wsb-onbrand-panel);
  font-family: 'Dosis', sans-serif;
}

.wsb-hosts-live {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--wsb-bar-glint);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.wsb-hosts-live-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--wsb-live);
  box-shadow: 0 0 7px var(--wsb-live-glow);
}

.wsb-hosts-label {
  color: var(--wsb-onbrand-ink-muted);
  font-size: 13px;
  letter-spacing: 0.03em;
}

.wsb-hosts-list {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.wsb-host {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  width: 62px;
}

.wsb-host-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid var(--wsb-accent);
  background: var(--wsb-surface);
  object-fit: cover;
  box-shadow: 0 2px 4px var(--wsb-shadow);
}

.wsb-host-initial {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--wsb-accent-text);
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
}

.wsb-host-name {
  max-width: 62px;
  overflow: hidden;
  color: var(--wsb-onbrand-ink);
  font-size: 11px;
  line-height: 1.2;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ---------------------------------------------------------------- motion ---
   Nothing above depends on movement; the pulses are decoration only, so they
   are opt-in for anyone who has not asked for stillness.

   The colour transitions are here for the same reason. When the show calls
   After Dark the whole page is behind a veil while the stylesheets swap, so
   these are for the pieces the veil does not cover and for a look changed any
   other way -- they carry the colour across instead of snapping it. Only
   paint properties are listed: nothing here can move the window.
--------------------------------------------------------------------------- */

@media (prefers-reduced-motion: no-preference) {
  .wsb-live-launcher-dot,
  .wsb-hosts-live-dot {
    animation: wsbLiveBlink 2.4s ease-in-out infinite;
  }

  .wsb-vw-tool {
    transition: background-color 0.15s ease, color 0.15s ease;
  }

  .inner-sheets .wsb-live-launcher,
  .wsb-vw:not(.is-dragging),
  .wsb-vw-bar,
  .wsb-vw-count,
  .wsb-vw-item,
  .wsb-vw-item-cat,
  .wsb-vw-item-time,
  .wsb-vw-empty,
  .wsb-vw-foot,
  .wsb-hosts,
  .wsb-hosts-live,
  .wsb-hosts-label,
  .wsb-host-avatar,
  .wsb-host-name {
    transition:
      background-color var(--wsb-swap) ease,
      border-color var(--wsb-swap) ease,
      color var(--wsb-swap) ease,
      box-shadow var(--wsb-swap) ease;
  }

  /* The window's own shadow is also its snap-preview ring, which has to answer
     a drag immediately -- that one stays quick. */
  .wsb-vw:not(.is-dragging) {
    transition:
      background-color var(--wsb-swap) ease,
      border-color var(--wsb-swap) ease,
      color var(--wsb-swap) ease,
      box-shadow 0.15s ease;
  }
}

@keyframes wsbLiveBlink {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.35; }
}
`, "",{"version":3,"sources":["webpack://./src/components/live/LiveShow.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;+EAa+E;;AAE/E;;;;;;;;;;;6EAW6E;;AAE7E;EACE,gBAAgB;AAClB;;AAEA;;;;;;;yCAOyC;AACzC;;EAEE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gFAAgF;EAChF,yEAAyE;EACzE,6BAA6B;EAC7B;+CAC6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;6EAG6E;;AAE7E;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,mCAAmC;EACnC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,MAAM;EACN,SAAS;EACT,YAAY;AACd;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;8BAC8B;AAC9B;;EAEE,yEAAyE;AAC3E;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB,gBAAgB,2DAA2D;AAC/F;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB;4CAC0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,iBAAiB;;AAEjB;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC;;oEAEkE;EAClE,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;EACxC,6BAA6B,KAAK,sDAAsD;EACxF,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,sCAAsC;EACtC,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,qBAAqB;EACrB,qCAAqC;EACrC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,wBAAwB;;AAExB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB;;6FAE2F;AAC7F;;AAEA;mBACmB;AACnB;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;qEACqE;;AAErE;EACE;;;IAGE,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA,2EAA2E;EAC3E;IACE,aAAa;EACf;AACF;;AAEA;;;;;6EAK6E;;AAE7E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,8BAA8B;EAC9B,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;;;;;;;6EAS6E;;AAE7E;EACE;;IAEE,iDAAiD;EACnD;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;;;;;;;;;;;;;;IAcE;;;;qCAIiC;EACnC;;EAEA;kDACgD;EAChD;IACE;;;;2BAIuB;EACzB;AACF;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,aAAa,EAAE;AAC5B","sourcesContent":["/* -----------------------------------------------------------------------------\n   Live-show extras: the \"Verified this show\" launcher and its floating window,\n   and the \"tonight's hosts\" credit strip.\n\n   NO PALETTE COLOUR IS WRITTEN DOWN HERE. Everything comes from the --wsb-* tokens\n   declared in assets/css/BingoCard.css and re-declared by each theme, so this\n   window speaks whichever look is on screen -- burnt orange and cream on an\n   ordinary night, deep indigo and moonlight once the show calls After Dark --\n   without this file knowing either of them exists. A theme added next winter\n   themes all of it by setting a handful of variables.\n\n   Geometry, on the other hand, is fixed: sizes, spacing and radii never come\n   from a token, so changing the look can never move anything on the page.\n----------------------------------------------------------------------------- */\n\n/* --------------------------------------------------------------- launcher ---\n   The launcher lives in the same .inner-sheets slot the Google Sheets button\n   used to, so it inherits that slot's button styling from the inline stylesheet\n   in public/index.html. Those rules are `.inner-sheets button` (specificity\n   0,1,1), so the overrides below have to be at least as specific -- which is\n   also how the palette gets in, since that inline sheet cannot see the tokens.\n\n   The slot itself keeps a 200px floor -- the exact width of the button that\n   used to live here. Nothing is drawn when there is no show on (the slot has no\n   background or border of its own), but the header geometry stays put, so the\n   logo does not slide sideways the moment a show ends.\n--------------------------------------------------------------------------- */\n\n.inner-sheets {\n  min-width: 200px;\n}\n\n/* The label's font is pinned on the button AND on everything inside it. Every\n   theme stylesheet opens with a `* { font-family: ... }` reset, and a universal\n   selector beats an inherited value on the spans however specific the rule on\n   their parent is -- so before this the label was Dosis in the everyday look\n   and Helvetica under After Dark. That is wider, \"Verified this show\" wrapped\n   to two lines, and the button grew 16px taller the moment the lights went out,\n   pushing the hosts strip and the whole card down with it. Pinned, the header\n   does not move when the look changes. */\n.inner-sheets .wsb-live-launcher,\n.inner-sheets .wsb-live-launcher * {\n  font-family: 'Dosis', sans-serif;\n}\n\n.inner-sheets .wsb-live-launcher {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  line-height: 1.2;\n  background: linear-gradient(to bottom, var(--wsb-surface), var(--wsb-surface-2));\n  /* The readable form of the accent: this is a 14px label, not a swatch. */\n  color: var(--wsb-accent-text);\n  /* An inset ring rather than a border: a dark theme needs the button's edge\n     drawn, and inset shadows cost no layout. */\n  box-shadow: inset 0 0 0 1px var(--wsb-ring);\n}\n\n.inner-sheets .wsb-live-launcher:hover {\n  background: var(--wsb-surface-hover);\n}\n\n.inner-sheets .wsb-live-launcher:focus-visible {\n  outline: 2px solid var(--wsb-focus);\n  outline-offset: 2px;\n}\n\n.wsb-live-launcher-dot {\n  width: 9px;\n  height: 9px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  background: var(--wsb-live);\n  box-shadow: 0 0 6px var(--wsb-live-glow);\n}\n\n.wsb-live-launcher-count {\n  flex: 0 0 auto;\n  min-width: 22px;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: var(--wsb-accent);\n  color: var(--wsb-accent-ink);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n/* ----------------------------------------------------------------- window ---\n   z-index sits above the confirmation toasts (1000) and below SweetAlert's\n   modal layer (1060), so the \"you win!\" dialog is never buried.\n--------------------------------------------------------------------------- */\n\n.wsb-vw {\n  position: fixed;\n  z-index: 1040;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: 'Dosis', sans-serif;\n  font-size: 15px;\n  color: var(--wsb-ink);\n  text-align: left;\n  background-color: var(--wsb-surface);\n  background-image: var(--wsb-surface-image);\n  border: 1px solid var(--wsb-accent);\n  border-radius: 20px;\n  box-shadow: 0 10px 15px var(--wsb-shadow);\n}\n\n.wsb-vw:focus {\n  outline: none;\n}\n\n.wsb-vw.is-docked {\n  top: 0;\n  bottom: 0;\n  height: auto;\n}\n\n.wsb-vw.is-dock-left {\n  left: 0;\n  border-left: none;\n  border-radius: 0 20px 20px 0;\n}\n\n.wsb-vw.is-dock-right {\n  right: 0;\n  border-right: none;\n  border-radius: 20px 0 0 20px;\n}\n\n/* Drag near an edge and the window leans that way before you let go, so the\n   snap is never a surprise. */\n.wsb-vw.will-dock-left,\n.wsb-vw.will-dock-right {\n  box-shadow: 0 10px 15px var(--wsb-shadow), 0 0 0 3px var(--wsb-snap-ring);\n}\n\n/* --- title bar --- */\n\n.wsb-vw-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 0 0 auto;\n  padding: 9px 10px;\n  background: var(--wsb-bar-bg);\n  color: var(--wsb-bar-ink);\n  cursor: grab;\n  user-select: none;\n  touch-action: none;               /* a touch drag must move the window, not scroll the page */\n}\n\n.wsb-vw.is-dragging .wsb-vw-bar {\n  cursor: grabbing;\n}\n\n.wsb-vw-dot {\n  width: 9px;\n  height: 9px;\n  flex: 0 0 auto;\n  border-radius: 50%;\n  background: var(--wsb-bar-glint);\n  box-shadow: 0 0 6px var(--wsb-bar-glint);\n}\n\n.wsb-vw-title {\n  flex: 1 1 auto;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* Not a palette colour: a hair of black under the letters so the title stays\n     crisp on any bar fill, light or dark. */\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.35);\n}\n\n.wsb-vw-count {\n  flex: 0 0 auto;\n  min-width: 22px;\n  padding: 1px 7px;\n  border-radius: 999px;\n  background: var(--wsb-badge-bg);\n  color: var(--wsb-badge-ink);\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.wsb-vw-tools {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex: 0 0 auto;\n}\n\n.wsb-vw-tool {\n  width: 26px;\n  height: 26px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: var(--wsb-bar-ink-muted);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.wsb-vw-tool:hover,\n.wsb-vw-tool.is-on {\n  background: var(--wsb-bar-hover);\n  color: var(--wsb-bar-ink);\n}\n\n.wsb-vw-tool:focus-visible {\n  outline: 2px solid var(--wsb-bar-glint);\n  outline-offset: 1px;\n}\n\n/* --- list --- */\n\n.wsb-vw-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  /* The scrollbar is part of the window, so it is painted in the window's own\n     colours rather than the operating system's. Firefox takes the pair of\n     colours; every other engine reads the ::-webkit- rules below. */\n  scrollbar-width: thin;\n  scrollbar-color: var(--wsb-line-strong) transparent;\n}\n\n.wsb-vw-body::-webkit-scrollbar {\n  width: 10px;\n}\n\n.wsb-vw-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.wsb-vw-body::-webkit-scrollbar-thumb {\n  background-color: var(--wsb-line-strong);\n  border: 3px solid transparent;    /* insets the thumb without changing the track width */\n  border-radius: 999px;\n  background-clip: padding-box;\n}\n\n.wsb-vw-body::-webkit-scrollbar-thumb:hover {\n  background-color: var(--wsb-accent);\n}\n\n.wsb-vw-list {\n  list-style: none;\n  margin: 0;\n  padding: 4px 12px 8px;\n}\n\n.wsb-vw-item {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  padding: 8px 0;\n  border-bottom: 1px dashed var(--wsb-line);\n}\n\n.wsb-vw-item:last-child {\n  border-bottom: none;\n}\n\n.wsb-vw-item-main {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.wsb-vw-item-text {\n  display: block;\n  font-size: 15px;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.wsb-vw-item-cat {\n  display: inline-block;\n  margin-top: 4px;\n  padding: 1px 8px;\n  background: var(--wsb-chip-bg);\n  border: 1px solid var(--wsb-chip-line);\n  border-radius: 999px;\n  color: var(--wsb-accent-text);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.wsb-vw-item-time {\n  flex: 0 0 auto;\n  color: var(--wsb-ink-muted);\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.wsb-vw-empty {\n  margin: 0;\n  padding: 28px 18px;\n  color: var(--wsb-ink-muted);\n  font-size: 15px;\n  text-align: center;\n}\n\n.wsb-vw-foot {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  flex: 0 0 auto;\n  padding: 6px 12px 8px;\n  border-top: 1px solid var(--wsb-line);\n  color: var(--wsb-ink-muted);\n  font-size: 11px;\n}\n\n.wsb-vw-foot-tz {\n  white-space: nowrap;\n  opacity: 0.85;\n}\n\n/* --- resize grip --- */\n\n.wsb-vw-grip {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 20px;\n  height: 20px;\n  cursor: nwse-resize;\n  touch-action: none;\n  background:\n    linear-gradient(135deg, transparent 52%, var(--wsb-line-strong) 52%, var(--wsb-line-strong) 62%, transparent 62%,\n    transparent 72%, var(--wsb-line-strong) 72%, var(--wsb-line-strong) 82%, transparent 82%);\n}\n\n/* Docked, the only useful handle is the inner edge: it sets how wide the\n   side panel is. */\n.wsb-vw-grip.is-edge {\n  top: 0;\n  bottom: 0;\n  width: 7px;\n  height: auto;\n  cursor: ew-resize;\n  background: var(--wsb-line);\n}\n\n.wsb-vw.is-dock-left .wsb-vw-grip.is-edge {\n  right: 0;\n  left: auto;\n}\n\n.wsb-vw.is-dock-right .wsb-vw-grip.is-edge {\n  left: 0;\n  right: auto;\n}\n\n.wsb-vw-grip.is-edge:hover {\n  background: var(--wsb-line-strong);\n}\n\n/* --- narrow screens: a bottom sheet beats a postage-stamp window ---\n   !important because floating position and size are inline styles. */\n\n@media (max-width: 700px) {\n  .wsb-vw,\n  .wsb-vw.is-docked,\n  .wsb-vw.is-floating {\n    left: 0 !important;\n    right: 0 !important;\n    top: auto !important;\n    bottom: 0 !important;\n    width: auto !important;\n    height: 62vh !important;\n    max-height: 62vh;\n    border-radius: 20px 20px 0 0;\n    border-left: none;\n    border-right: none;\n    border-bottom: none;\n  }\n\n  .wsb-vw-bar {\n    cursor: default;\n  }\n\n  .wsb-vw-grip {\n    display: none;\n  }\n\n  /* Docking is a pointer idea; on a phone the sheet is already glued down. */\n  .wsb-vw-tool:not(.wsb-vw-close) {\n    display: none;\n  }\n}\n\n/* ------------------------------------------------------------ hosts strip ---\n   Sits on the card's own header panel rather than on a surface of its own, so\n   it reads as part of the card. Its colours come from the --wsb-onbrand-*\n   tokens, which mean \"on the header, whatever the header is tonight\": a dark\n   wash and cream text over burnt orange, a lit wash and moonlight over indigo.\n--------------------------------------------------------------------------- */\n\n.wsb-hosts {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  margin: 0 20px 12px;\n  padding: 7px 16px;\n  border: 1px solid var(--wsb-onbrand-line);\n  border-radius: 20px;\n  background: var(--wsb-onbrand-panel);\n  font-family: 'Dosis', sans-serif;\n}\n\n.wsb-hosts-live {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--wsb-bar-glint);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.wsb-hosts-live-dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--wsb-live);\n  box-shadow: 0 0 7px var(--wsb-live-glow);\n}\n\n.wsb-hosts-label {\n  color: var(--wsb-onbrand-ink-muted);\n  font-size: 13px;\n  letter-spacing: 0.03em;\n}\n\n.wsb-hosts-list {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.wsb-host {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n  width: 62px;\n}\n\n.wsb-host-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 2px solid var(--wsb-accent);\n  background: var(--wsb-surface);\n  object-fit: cover;\n  box-shadow: 0 2px 4px var(--wsb-shadow);\n}\n\n.wsb-host-initial {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--wsb-accent-text);\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.wsb-host-name {\n  max-width: 62px;\n  overflow: hidden;\n  color: var(--wsb-onbrand-ink);\n  font-size: 11px;\n  line-height: 1.2;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ---------------------------------------------------------------- motion ---\n   Nothing above depends on movement; the pulses are decoration only, so they\n   are opt-in for anyone who has not asked for stillness.\n\n   The colour transitions are here for the same reason. When the show calls\n   After Dark the whole page is behind a veil while the stylesheets swap, so\n   these are for the pieces the veil does not cover and for a look changed any\n   other way -- they carry the colour across instead of snapping it. Only\n   paint properties are listed: nothing here can move the window.\n--------------------------------------------------------------------------- */\n\n@media (prefers-reduced-motion: no-preference) {\n  .wsb-live-launcher-dot,\n  .wsb-hosts-live-dot {\n    animation: wsbLiveBlink 2.4s ease-in-out infinite;\n  }\n\n  .wsb-vw-tool {\n    transition: background-color 0.15s ease, color 0.15s ease;\n  }\n\n  .inner-sheets .wsb-live-launcher,\n  .wsb-vw:not(.is-dragging),\n  .wsb-vw-bar,\n  .wsb-vw-count,\n  .wsb-vw-item,\n  .wsb-vw-item-cat,\n  .wsb-vw-item-time,\n  .wsb-vw-empty,\n  .wsb-vw-foot,\n  .wsb-hosts,\n  .wsb-hosts-live,\n  .wsb-hosts-label,\n  .wsb-host-avatar,\n  .wsb-host-name {\n    transition:\n      background-color var(--wsb-swap) ease,\n      border-color var(--wsb-swap) ease,\n      color var(--wsb-swap) ease,\n      box-shadow var(--wsb-swap) ease;\n  }\n\n  /* The window's own shadow is also its snap-preview ring, which has to answer\n     a drag immediately -- that one stays quick. */\n  .wsb-vw:not(.is-dragging) {\n    transition:\n      background-color var(--wsb-swap) ease,\n      border-color var(--wsb-swap) ease,\n      color var(--wsb-swap) ease,\n      box-shadow 0.15s ease;\n  }\n}\n\n@keyframes wsbLiveBlink {\n  0%, 100% { opacity: 1; }\n  50%      { opacity: 0.35; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
